<template>
  <div ref="design">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        style="text-align: left;height: 800px"
        router
        >
        <template v-if="$store.getters.getStorage.user.user.roleName == 'manager'">
             <el-menu-item index="/design/projectQuery">
            <i class="el-icon-tickets"></i>
            <span slot="title" >项目查询</span>
          </el-menu-item>
          <el-menu-item index="/design/task">
            <i class="el-icon-tickets"></i>
            <span slot="title" >任务分配</span>
          </el-menu-item>
          <el-menu-item index="/design/drawing">
            <i class="el-icon-tickets"></i>
            <span slot="title" >图纸上传</span>
          </el-menu-item>
          <el-menu-item index="/design/supplement">
            <i class="el-icon-tickets"></i>
            <span slot="title" >补充上传</span>
          </el-menu-item>
          <el-menu-item index="/design/expertDownload">
            <i class="el-icon-tickets"></i>
            <span slot="title" >图纸下载</span>
          </el-menu-item>
          <el-menu-item index="/design/opinion">
            <i class="el-icon-tickets"></i>
            <span slot="title" >意见查看</span>
          </el-menu-item>
          <el-menu-item index="/design/taskWaitReply">
            <i class="el-icon-tickets"></i>
            <span slot="title" >任务回复</span>
          </el-menu-item>
          <el-menu-item index="/design/userManagerList" >
            <i class="el-icon-tickets"></i>
            <span slot="title">员工管理</span>
          </el-menu-item>
          <el-menu-item index="/design/infoList" >
            <i class="el-icon-tickets"></i>
            <span slot="title" >信息维护</span>
          </el-menu-item>
          <el-menu-item index="/design/report" v-if="this.$store.getters.getStorage.city !='fj'">
            <i class="el-icon-tickets"></i>
            <span slot="title" >报表统计</span>
          </el-menu-item>
        
        </template>
        <template v-else>
          <el-menu-item index="/design/drawing" >
            <i class="el-icon-tickets"></i>
            <span slot="title" >图纸上传</span>
          </el-menu-item>
          <el-menu-item index="/design/supplement">
            <i class="el-icon-tickets"></i>
            <span slot="title" >补充上传</span>
          </el-menu-item>
          <el-menu-item index="/design/opinion">
            <i class="el-icon-tickets"></i>
            <span slot="title" >意见查看</span>
          </el-menu-item>
          <el-menu-item index="/design/report">
            <i class="el-icon-tickets"></i>
            <span slot="title" >报表统计</span>
          </el-menu-item>
          <el-menu-item index="/design/taskWaitReply">
            <i class="el-icon-tickets"></i>
            <span slot="title" >任务回复</span>
          </el-menu-item>
          <el-menu-item index="/design/allocation">
            <i class="el-icon-tickets"></i>
            <span slot="title" >任务分配</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        sysUserName: '',
        sysUserAvatar: '',
        collapsed: false,
        clientHeight:'',
      }
    },
    mounted() {
      //初始化
      // 获取浏览器可视区域高度
      this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`;
      };
      
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        this.changeFixed(this.clientHeight)
      }
    },
    methods: {
      changeFixed(clientHeight){
       /* //动态修改样式
        this.$store.commit('$_setHeight',clientHeight+'px');
        this.$refs.design.style.height = clientHeight+'px';*/

      },
      
    }
  }
</script>
<style>
  html,body,#app{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/DesignLeft.vue